import { render, staticRenderFns } from "./SmsLogs.vue?vue&type=template&id=1cb27b40&scoped=true"
import script from "./SmsLogs.vue?vue&type=script&lang=js"
export * from "./SmsLogs.vue?vue&type=script&lang=js"
import style0 from "./SmsLogs.vue?vue&type=style&index=0&id=1cb27b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb27b40",
  null
  
)

export default component.exports